export type CaptchaOperator = '+' | '-';

export type MathCaptchaState = {
  expression: string;
  result: number;
  seed: string;
};

const getRandomDigit = (max = 9) => Math.floor(Math.random() * (max + 1));

const getRandomOperator = (): CaptchaOperator => (Math.random() < 0.5 ? '+' : '-');

export const calculateCaptchaResult = (
  first: number,
  operator1: CaptchaOperator,
  second: number,
  operator2: CaptchaOperator,
  third: number,
) => {
  const interim = operator1 === '+' ? first + second : first - second;
  return operator2 === '+' ? interim + third : interim - third;
};

export const generateCaptcha = (): MathCaptchaState => {
  const first = getRandomDigit();
  const operator1 = getRandomOperator();
  const second = operator1 === '-' ? getRandomDigit(first) : getRandomDigit();
  const interim = operator1 === '+' ? first + second : first - second;

  const operator2 = getRandomOperator();
  const third = operator2 === '-' ? getRandomDigit(Math.min(interim, 9)) : getRandomDigit();

  const expression = `${first}${operator1}${second}${operator2}${third}`;
  const result = calculateCaptchaResult(first, operator1, second, operator2, third);

  return {
    expression,
    result,
    seed: `${expression}-${Math.random().toString(36).slice(2, 10)}`,
  };
};
